export const SUGGESTION_CONTEXTS = {
  ROOT: 'ROOT',
  PATH_DRILL_DOWN: 'PATH_DRILL_DOWN',
  OPERATOR: 'OPERATOR',
  VALUE: 'VALUE',
  ITERATOR: 'ITERATOR',
  NONE: 'NONE',
};

export const DATE_OPERATOR_GLOSSES = {
  '==': 'is on',
  '!=': 'is not on',
  '>': 'is after',
  '<': 'is before',
  '>=': 'is on or after',
  '<=': 'is on or before',
};

export const OPERATOR_GLOSSES = {
  '==': 'is equal to',
  '!=': 'is not equal to',
  '>=': 'is at least',
  '<=': 'is at most',
  '>': 'is more than',
  '<': 'is less than',
  '+': 'plus',
  '-': 'minus',
  '*': 'multiplied by',
  '/': 'divided by',
  contains: 'text contains (substring — not list membership)',
  startsWith: 'text starts with',
  endsWith: 'text ends with',
};

export const DEFAULT_OPERATORS_BY_CATEGORY = {
  numeric: ['==', '!=', '>', '<', '>=', '<=', '+', '-', '*', '/'],
  string: ['==', '!=', 'contains', 'startsWith', 'endsWith'],
  bool: ['==', '!='],
  date: ['==', '!=', '>', '<', '>=', '<='],
  enum: ['==', '!='],
};
